/*
 * @Author: your name
 * @Date: 2021-10-18 14:29:13
 * @LastEditTime: 2021-11-09 13:02:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\views\home\Home.js
 */
// eslint-disable-next-line no-unused-vars
import {
  getUrl,
  getContent,
  getSearch,
  submitContent,
  getverlist,
  getHistoryZWContent,
  addComment,
  delComment,
  editComment
} from '@/api/index'
import { UserDataChange } from '@/api/user'
import {
  GET_USER,
  REMOVE_TOKEN
} from '@/utils/auth'
import bindScroll from '@/utils/scrollspy.js'
import md5 from 'js-md5'
import tinymce from 'tinymce/tinymce'

export default {
  data() {
    return {
      msg: '',
      disabled: false,
      userInfo: {},
      userStatus: {
        // 用户权限
        write: 0, // 用户是否可以编辑 0 只读, 1 可编辑
        translated: 0 // 0 翻译中, 1 审核中
      },
      urlList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      },
      zhContent: [], // 中文经文
      zwContent: '', // 藏文经文
      zjContent: [], // 经文注释
      tibetanComments: [], // 藏文批注列表
      // 批注相关
      commentDialogVisible: false,
      isEditMode: false,
      currentSelectedText: '',
      currentEditingCommentId: null,
      commentForm: {
        content: ''
      },
      oldContent: '',
      lastSavedSignature: '', // 最近一次已保存内容签名
      drawer: false, // 搜索左弹框
      direction: 'rtl', // 搜索弹框位置
      drawerHistory: false, // 修订历史弹框
      searchBtnIsShow: false,
      keyword: '',
      copyText: '', // 去掉角标后的选中文字，供复制使用
      searchList: [], // 搜索列表
      timer: null,
      filePath: '',
      isScroll: false,
      isEdit: true,
      dialogSubmit: false, // 提交弹框
      submitForm: {
        remark: '', // 备注
        translated: '0' // 是否完成翻译
      }, // 提交编辑信息
      editHistoryList: [], // 提交历史列表
      historyNum: 0,
      historyLoading: false, // 修订历史内容加载中
      subTimer: 0.1,
      historyZWContent: '', // 历史版本藏文内容
      inline: false, // 富文本编辑器展示模式 true为内联模式 false为非内联模式(iframe方式嵌入)
      editNum: 1000, // 富文本插件父盒子的key, 可以在改变内联模式后强制更新富文本组件
      passFrom: {
        password: '',
        nickname: '',
        description: ''
      },
      passChangeDialog: false,
      // 字体大小设置
      showFontSizeDialog: false,
      contentFontSize: 16,
      // 页面全局字体大小设置
      showPageFontDialog: false,
      pageFontSize: 16,
      // 背景颜色设置
      showBgColorDialog: false,
      currentBgColor: '#f6f8f3',
      eyeProtectionColors: [
        { name: '默认', value: '#f6f8f3' },
        { name: '米黄', value: '#fdf6e3' },
        { name: '浅绿', value: '#e8f5e9' },
        { name: '护眼绿', value: '#c7edcc' },
        { name: '浅灰', value: '#f5f5f5' },
        { name: '护眼蓝', value: '#e6f3ff' },
        { name: '暖黄', value: '#fffae6' },
        { name: '柔和灰', value: '#f0f0f0' }
      ]
    }
  },
  computed: {
    userIsEdit() {
      const isEdit =
        this.zwContent === '' ||
        this.userInfo.groupid === '0' ||
        ~~this.userStatus.write === 0
      return isEdit
    }
  },
  watch: {
    zwContent: {
      handler(v) {
        // 空内容不自动保存
        if (v === '') return

        // 与最近一次保存快照一致时，不触发自动保存（避免失焦等无实质变化触发）
        const currentSignature = this.buildContentSignature()
        if (currentSignature === this.lastSavedSignature) {
          window.console.log('[AutoSave][skip] signature unchanged', {
            currentLength: currentSignature.length,
            savedLength: this.lastSavedSignature.length
          })
          return
        }

        window.console.log('[AutoSave][watch-triggered]', {
          currentLength: currentSignature.length,
          savedLength: this.lastSavedSignature.length,
          changed: currentSignature !== this.lastSavedSignature
        })

        if (this.subTimer) {
          clearTimeout(this.subTimer)
        }

        this.subTimer = setTimeout(() => {
          // 再次校验，避免定时期间内容回到已保存状态
          const latestSignature = this.buildContentSignature()
          if (latestSignature === this.lastSavedSignature) {
            window.console.log('[AutoSave][skip-in-timer] signature unchanged before submit', {
              latestLength: latestSignature.length,
              savedLength: this.lastSavedSignature.length
            })
            return
          }

          window.console.log('[AutoSave][submit-start]', {
            latestLength: latestSignature.length,
            savedLength: this.lastSavedSignature.length
          })

          this.msg = '保存中...'
          const data = {
            path: this.filePath,
            langtype: 2,
            userid: this.userInfo.userid,
            contents: this.contentToArr()
          }
          this.submitEdit(data, () => {
            window.console.log('[AutoSave][submit-success] 自动保存成功')
            this.lastSavedSignature = latestSignature
            window.console.log('[AutoSave][signature-updated]', {
              savedLength: this.lastSavedSignature.length
            })
            this.msg = '已自动保存'
            setTimeout(() => {
              const date = new Date()
              const s = date.getHours()
              const f = date.getMinutes()
              this.msg =
                '最近保存   ' +
                `${s > 9 ? s : '0' + s}:${
                  f > 9 ? f : '0' + f
                }`
            }, 1800)
          })
        }, 2000)
      },
      deep: true
    }
  },
  created() {
    this.userInfo = GET_USER()
    this.isEdit = !(this.userInfo.groupid === '51')
    this.getUrlList('/', true)
    // 从本地存储加载设置
    this.loadSettings()
  },
  mounted() {
    document.addEventListener('click', () => {
      this.drawer = false
      this.searchBtnIsShow = false
    })
    this.$nextTick(() => {
      this.resizeBoxChange()
      // 初始化编辑器样式
      this.$nextTick(() => {
        this.updateEditorStyle()
      })
    })
    window.addEventListener(
      'resize',
      this.resizeBoxChange
    )
    if (window.$) {
      bindScroll()
    }
  },
  methods: {
    resizeBoxChange() {
      const aside = this.$refs.homeAside
      const content = this.$refs.zhongwenBox
      const resizeBox = this.$refs.resize
      const resizeBox1 = this.$refs.resize1
      const w = aside.offsetWidth
      const h = content.offsetHeight
      resizeBox.style.left = w + 16 + 'px'
      resizeBox1.style.left = w + 20 + 'px'
      resizeBox1.style.top = h + 17 + 'px'
      if (!this.isEdit) {
        resizeBox1.style.display = 'none'
      }
    },
    resize1Mousedown(e) {
      e.preventDefault()
      if (!this.isEdit) return
      // const zangwenBox = this.$refs.leftBottom
      const zhongwenBox = this.$refs.zhongwenBox
      const resizeBox1 = this.$refs.resize1
      const h = zhongwenBox.offsetHeight
      const y1 = e.clientY
      document.onmousemove = function(ev) {
        ev.preventDefault()
        const y2 = ev.clientY
        const yNum = y2 - y1

        zhongwenBox.style.height =
            h + yNum + 'px'
        // zangwenBox.style.height =
        //   h - yNum + 'px'
        resizeBox1.style.top = h + yNum + 17 + 'px'
      }
      document.onmouseup = function() {
        document.onmousemove = null
      }
    },
    resizeMousedown(e) {
      e.preventDefault()
      const content = this.$refs.homeContent
      const aside = this.$refs.homeAside
      const resizeBox = this.$refs.resize
      const resizeBox1 = this.$refs.resize1
      const w = aside.offsetWidth
      resizeBox.style.left = w + 16 + 'px'
      const x1 = e.clientX
      const oldWidth = content.offsetWidth
      document.onmousemove = function(ev) {
        ev.preventDefault()
        const x2 = ev.clientX

        const x = x2 - x1

        content.style.width = oldWidth - x + 'px'
        resizeBox.style.left = w + 16 + x + 'px'
        resizeBox1.style.left = w + x + 20 + 'px'
      }
      document.onmouseup = function() {
        document.onmousemove = null
      }
    },
    // asideMousedown(e) {
    //   const content = this.$refs.homeContent
    //   const aside = this.$refs.homeAside
    //   const w = aside.offsetWidth
    //   const asx = e.offsetX
    //   if (asx < w && asx > w - 25) {
    //     const x1 = e.clientX
    //     const oldWidth = content.offsetWidth
    //     document.onmousemove = function(ev) {
    //       ev.preventDefault()
    //       const x2 = ev.clientX

    //       const x = x2 - x1

    //       content.style.width =
    //         oldWidth - x + 'px'
    //     }
    //   }
    //   document.onmouseup = function() {
    //     document.onmousemove = null
    //   }
    // },
    closePassDiolog() {
      this.passFrom.password = ''
      this.passFrom.nickname = ''
      this.passFrom.description = ''
      this.passChangeDialog = false
    },
    submitInfo(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (
            this.passFrom.password === '' &&
            this.passFrom.nickname === '' &&
            this.passFrom.description === ''
          ) {
            this.$message.warning(
              '请输入要修改的信息！'
            )
          } else {
            const { name } = JSON.parse(
              window.localStorage.getItem(
                'userInfo'
              ) || {}
            )
            if (name) {
              this.passFrom.name = name
            }
            let {
              password,
              // eslint-disable-next-line prefer-const
              nickname,
              // eslint-disable-next-line prefer-const
              description
            } = this.passFrom
            password = password ? md5(
              this.passFrom.password
            ) : ''
            UserDataChange({
              nickname,
              name,
              description,
              password
            }).then(res => {
              if (res.code === 200) {
                this.$message.success(
                  '修改成功！'
                )
                this.closePassDiolog()
              } else {
                this.$message.warning(
                  '修改失败！'
                )
              }
            })
          }
        }
      })
    },
    passChange() {
      this.passChangeDialog = true
    },
    editIsChange() {
      this.isEdit = !this.isEdit
      // this.inline = !this.isEdit
      const zhongwenBox = this.$refs.zhongwenBox
      const resizeBox1 = this.$refs.resize1
      if (!this.isEdit) {
        zhongwenBox.style.height = '100%'
        resizeBox1.style.display = 'none'
      } else {
        zhongwenBox.style.height = '50%'
        resizeBox1.style.display = 'block'
        // 更新 resize1 的位置
        const h = zhongwenBox.offsetHeight
        resizeBox1.style.top = h + 17 + 'px'
      }
      this.inline = false
      this.editNum += 1000
      // 重新应用批注标记
      setTimeout(() => {
        this.applyCommentMarks()
      }, 600)
    },
    restoreSubmit(item) {
      this.$confirm('确定还原此版本吗?')
        .then(() => {
          const data = {
            path: this.filePath,
            userid: item.userid,
            langtype: 2,
            contents: this.contentToArr()
          }
          const cb = () => {
            this.historyNum = 0
            this.drawerHistory = false
            this.$message.success('还原成功！')
          }
          this.submitEdit(data, cb)
        })
        .catch(() => {})
    },
    historyBoxClose(done) {
      // 历史版本弹框关闭之前
      this.historyNum = 0
      this.historyLoading = false
      this.editHistoryList = []
      this.historyZWContent = ''
      done()
    },
    restore(item, index) {
      // 点击历史版本
      this.historyNum = index
      this.historyLoading = true
      // 切换时先清空旧内容，避免视觉残留
      this.historyZWContent = ''
      this.$nextTick(() => {
        const historyBox = this.$refs.historyContentBox
        if (historyBox) {
          historyBox.scrollTop = 0
        }
      })

      const data = {
        path: this.filePath,
        langtype: 2,
        userid: item.userid,
        versionid: item.versionid
      }
      getHistoryZWContent(data)
        .then(res => {
          if (res.data?.contents) {
            res.data.contents.forEach(i => {
              this.historyZWContent += `<p>  ${
                i.content !== '' ? i.content : ''
              } </p>`
            })
          }
        })
        .finally(() => {
          this.historyLoading = false
          this.$nextTick(() => {
            const historyBox = this.$refs.historyContentBox
            if (historyBox) {
              historyBox.scrollTop = 0
            }
          })
        })
    },
    lookHistory() {
      // 查看历史版本弹框
      this.drawerHistory = true
      this.historyLoading = true
      this.editHistoryList = []
      this.historyZWContent = ''
      this.historyNum = 0

      const data = {
        path: this.filePath,
        langtype: 2,
        userid: this.userInfo.userid
      }
      getverlist(data)
        .then(res => {
          if (
            res.code === 200 &&
            res.data?.versionlist
          ) {
            this.editHistoryList =
              res.data.versionlist
            if (this.editHistoryList.length > 0) {
              // 打开弹框默认加载第一个历史改动内容
              this.restore(this.editHistoryList[0], 0)
            } else {
              this.historyLoading = false
            }
          } else {
            this.historyLoading = false
          }
        })
        .catch(() => {
          this.historyLoading = false
        })
    },
    loginOut() {
      // 退出登录
      REMOVE_TOKEN()
      this.$router.push('/login')
    },
    nodeClick(data, node) {
      if (
        node.level === 2 &&
        node.childNodes?.length > 0 &&
        node.expanded
      ) {
        this.getAllData(data)
      }
    },
    clickToContent(node, data) {
      const { id } = data
      if (id) {
        // 点击段名去正文
        const zsId = document.getElementById(
          `zw${id}`
        )
        if (zsId) {
          const contentBox = this.$refs
            .zhongwenBox
          const zsTop = zsId.offsetTop - 25
          contentBox.scrollTo(0, zsTop)
        }
        const ifr = document.querySelector(
          'iframe'
        )
        const zangwenBox =
          ifr?.contentDocument.getElementById(
            'tinymce'
          ) || document.getElementById('zwEdit')
        if (zangwenBox?.children?.length > 1) {
          for (
            let i = 0;
            i < zangwenBox.children.length;
            i++
          ) {
            const item = zangwenBox.children[i]
            let itemstr = item.innerText.match(
              /\（([^\)]+)\）/
            )
            let datastr = data.name.match(
              /\（([^\)]+)\）/
            )
            if (itemstr) {
              itemstr = itemstr[0]
            }
            if (datastr) {
              datastr = datastr[0]
            }
            if (
              item.innerText === data.name ||
              (itemstr !== null &&
                itemstr === datastr)
            ) {
              if (ifr) {
                ifr.contentWindow.scroll(
                  0,
                  item.offsetTop
                )
              } else {
                setTimeout(() => {
                  zangwenBox.scrollTo(
                    0,
                    item.offsetTop
                  )
                }, 100)
              }
              break
            }
          }
        }
      }
    },
    submit() {
      // 提交编辑
      this.$confirm(
        '是否提交本次编辑的内容! ',
        '提示'
      )
        .then(() => {
          const {
            remark,
            translated
          } = this.submitForm
          const data = {
            path: this.filePath,
            langtype: 2,
            userid: this.userInfo.userid,
            contents: this.contentToArr(),
            remark,
            translated: Number(translated)
          }
          this.submitEdit(data, () => {
            this.$message.success('提交成功! ')
          })
        })
        .catch(() => {})
    },
    contentToArr() {
      const arr = []
      this.zwContent
        .split('\n')
        .forEach((i, x) => {
          // 移除 HTML 标签，只保留纯文本
          const plainText = i.replace(/<[^>]*>/g, '')
          arr.push({
            paragraphindex: x + 1,
            content: plainText
          })
        })
      return arr
    },
    // 生成当前藏文内容的签名，用于判断是否有实际改动
    // 说明：编辑器初次 focus/blur 可能会做一次格式归一化（如空格、空行），这里做同样的归一化避免误判
    buildContentSignature() {
      const normalized = this.contentToArr().map(item => ({
        paragraphindex: Number(item.paragraphindex),
        content: (item.content || '').replace(/\s+/g, ' ').trim()
      }))

      // 去掉末尾连续空行，避免首次失焦时因尾部空段落差异触发自动保存
      let end = normalized.length - 1
      while (end >= 0 && normalized[end].content === '') {
        end--
      }

      return JSON.stringify(normalized.slice(0, end + 1))
    },
    submitEdit(data, callback) {
      // 发送提交编辑
      submitContent(data)
        .then(res => {
          if (res.code === 200) {
            this.dialogSubmit = false
            this.submitForm = {
              remark: '', // 备注
              translated: '0' // 是否完成翻译
            }
            this.lastSavedSignature = JSON.stringify(data.contents || [])
            callback && callback()
          } else {
            this.$message.error(res.message)
            this.msg = '网络异常，提交失败！'
          }
        })
        .catch(() => {
          this.msg = '网络异常，提交失败！'
        })
    },
    boxScrollChange(id) {
      // 滚动条联动
      if (!this.isScroll) return
      const box1 = this.$refs.zhongwenBox
      // const box2 = this.$refs.zangwenBox
      const box2 = document.getElementById(
        'zwEdit'
      )
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        // if (id === 'zangwenBox') {
        // box1.scrollTop = box2.scrollTop
        // } else if (id === 'zhongwenBox') {
        box2.scrollTop = box1.scrollTop
        // }
      }, 300)
    },
    colorred(v) {
      // 搜索关键字高亮
      const reg = new RegExp(this.keyword, 'g')
      return v.replace(
        reg,
        `<span class="red">${this.keyword}</span>`
      )
    },
    searchZS() {
      this.drawer = true
      if (this.keyword === '') return
      // 搜索注释
      const data = {
        key: this.keyword,
        langtype: 1
      }
      getSearch(data).then(res => {
        if (res.data?.keys) {
          this.searchList = res.data.keys
        }
      })
    },
    searchClick() {
      // 点击搜索按钮
      this.searchZS()
      this.drawer = true
    },
    selectChange(e) {
      // 右键点击中文内容的时候
      const selection = window.getSelection()
      const selectKey = selection.toString()
      this.keyword = selectKey || ''
      let copyKey = selectKey
      if (selection.rangeCount) {
        const range = selection.getRangeAt(0)
        const box = this.$refs.zhongwenBox
        const container = range.commonAncestorContainer
        const containerEl = container.nodeType === 1 ? container : container.parentElement
        if (!box || !box.contains(containerEl)) {
          // 选区不在中文内容区域（如搜索抽屉、藏文编辑区），不作为复制内容
          copyKey = ''
        } else if (containerEl.closest('i.jz')) {
          // 选区完全落在角标内，视为没有选中有效文字
          copyKey = ''
        } else {
          const fragment = range.cloneContents()
          fragment.querySelectorAll('i.jz').forEach(el => el.remove())
          copyKey = fragment.textContent
        }
      }
      this.copyText = copyKey
      const btn = this.$refs.searchBtn
      btn.style.top = e.clientY + 'px'
      btn.style.left = e.clientX + 'px'
      this.searchBtnIsShow = true
    },
    execCopy(text) {
      const input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      let ok = false
      try {
        ok = document.execCommand('copy')
      } catch (e) {
        ok = false
      }
      document.body.removeChild(input)
      return ok
    },
    copyClick() {
      // 复制右键选中的文字（已去掉角标）
      const text = this.copyText
      if (!text) return
      const done = () => {
        this.searchBtnIsShow = false
        this.$message({ type: 'success', message: '复制成功' })
      }
      const fail = () => {
        this.$message({ type: 'warning', message: '复制失败，请重试' })
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => {
          this.execCopy(text) ? done() : fail()
        })
      } else {
        this.execCopy(text) ? done() : fail()
      }
    },
    zhitemClick(i, e) {
      // 点击中文注释, 跳到对应注释位置
      const item = e.target
      if (
        item.tagName === 'I' &&
        item.id.startsWith('zj')
      ) {
        const footnoteId = item.innerText

        // 先查找中文批注
        const chineseComment = document.getElementById(`tibetan${footnoteId}`)

        // 清除所有高亮
        document.querySelectorAll('.bg').forEach(el => {
          el.classList.remove('bg')
        })

        if (chineseComment) {
          // 高亮整个批注项
          chineseComment.classList.add('bg')

          // 滚动到中文批注位置
          const commentBox = document.querySelector('.right-top')
          if (commentBox) {
            const scrollTop = chineseComment.offsetTop - commentBox.offsetTop
            commentBox.scrollTo({ top: scrollTop - 10, behavior: 'smooth' })

            // 2秒后移除高亮
            setTimeout(() => {
              chineseComment.classList.remove('bg')
            }, 2000)
          }
        } else {
          console.warn(`未找到中文批注 tibetan${footnoteId}`)
        }
      }
    },
    chineseCommentClick(comment, e) {
      // 点击中文批注，跳转到左侧对应角标位置
      const footnoteId = comment.footnoteid

      // 查找左侧中文内容中的角标
      const footnoteMark = document.getElementById(`zj${footnoteId}`)

      // 清除所有高亮
      document.querySelectorAll('.bg').forEach(el => {
        el.classList.remove('bg')
      })

      if (footnoteMark) {
        // 高亮角标
        footnoteMark.classList.add('bg')

        // 滚动到角标位置
        const chineseBox = this.$refs.zhongwenBox
        if (chineseBox) {
          // 获取角标所在的段落元素
          const paragraphElement = footnoteMark.closest('p')
          if (paragraphElement) {
            // 计算滚动位置
            const scrollTop = paragraphElement.offsetTop - chineseBox.offsetTop

            // 滚动到目标位置
            chineseBox.scrollTo({ top: scrollTop - 10, behavior: 'smooth' })

            // 可选：添加临时高亮动画效果
            setTimeout(() => {
              footnoteMark.classList.remove('bg')
            }, 2000)
          }
        }
      } else {
        console.warn(`未找到角标 zj${footnoteId}`)
      }
    },
    zhcon(v) {
      // 格式化注解
      if (!v) return ''
      const reg = new RegExp('\\[(.+?)\\]', 'g')
      v = v.replace(
        reg,
        `<i class="jz" id="zj$1">$1</i>`
      )
      return v
    },
    resetContent() {
      // 清空内容
      this.zhContent = []
      this.zwContent = ''
      this.zjContent = []
      this.tibetanComments = []
      this.lastSavedSignature = ''
    },
    getZangContent(data) {
      // 请求藏文经文
      return getContent(data).then(res => {
        if (res.code === 200) {
          this.userStatus.write =
            res.data.write || 0
          this.disabled = res.data.write === 0
          this.userStatus.translated =
            res.data.translated || 0
          if (res.data.contents) {
            this.zwContent = ''
            let str = ''
            res.data.contents.forEach(i => {
              str += `<p>  ${
                i.content !== '' ? i.content : ''
              }</p> \n`
              // this.zwContent += i.content !== '' ? `<p>${i.content}</p>\n` : ''
            })
            this.zwContent = str
            this.subTimer = null
            this.oldContent = this.zwContent
            this.lastSavedSignature = this.buildContentSignature()
            // 延迟绑定批注点击事件，确保编辑器已加载内容
            setTimeout(() => {
              this.bindCommentClickEvents()
            }, 300)
            return Promise.resolve(true)
          }
        } else {
          return Promise.reject(res.message)
        }
      })
    },
    getAllData(data, cb) {
      this.filePath = data.path
      this.resetContent()
      const get1 = getContent({
        path: data.path,
        langtype: 1
      }).then(res => {
        // 请求中文经文
        if (res.code === 200) {
          this.zhContent =
            res.data.contents || []
          return Promise.resolve(true)
        }
      })
      const get2 = this.getZangContent({
        path: data.path,
        langtype: 2
      })
      const get3 = getContent({
        path: data.path,
        langtype: 3
      }).then(res => {
        // 请求中文经文注解
        if (res.code === 200) {
          this.zjContent =
            res.data.footnotes || []
          return Promise.resolve(true)
        }
      })
      const get4 = getContent({
        path: data.path,
        langtype: 5
      }).then(res => {
        // 请求藏文批注
        if (res.code === 200) {
          this.tibetanComments =
            res.data.comments || []
          return Promise.resolve(true)
        }
      })
      Promise.all([get1, get2, get3, get4]).then(
        ([r1, r2, r3, r4]) => {
          if (cb && ((r1 && r3 && r4) || r2)) {
            cb && cb()
          }
          // 所有数据加载完成后，应用批注标记
          // console.log('=== getAllData 完成，准备应用批注标记 ===')
          // console.log('r1, r2, r3, r4:', r1, r2, r3, r4)
          this.$nextTick(() => {
            // 等待 TinyMCE 编辑器完全初始化
            setTimeout(() => {
              // console.log('=== 开始调用 applyCommentMarks ===')
              this.applyCommentMarks()
            }, 500)
          })
        }
      )
    },

    // 点击箭头获取子目录
    loadNode(node, resolve) {
      this.subTimer = 0.1
      this.msg = ''
      if (node.level > 0 || node.level === 1) {
        if (node.data.path.indexOf('docx') > -1) {
          this.getAllData(node.data)
        }
        this.getUrlList(node.data.path, false)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            // this.$message.warning("请求出错");
            console.log(err)
            resolve()
          })
        // }
      }
    },
    // 格式化返回的数据格式
    formatting(list) {
      let arr = []
      arr = list.map((i, x) => {
        const item = i
        item.label = i.name
        item.leaf = !i.children
        item.id = i.lastmodify
          ? i.lastmodify + x
          : i.id
        if (i.name.indexOf('docx') > -1) {
          item.leaf = false
        }
        return item
      })
      return arr
    },
    async getUrlList(url, isclick) {
      // 获取目录列表
      let arr = []
      const res = await getUrl({ dir: url }).then(
        resData => {
          if (
            resData.code === 200 &&
            resData.data.dir
          ) {
            arr = this.formatting(
              resData.data.dir
            )
            if (isclick) {
              this.urlList = arr
            }
            return arr
          }
        }
      )
      return this.formatting(res)
    },
    // 字体大小和背景颜色设置方法
    loadSettings() {
      // 从本地存储加载正文字体大小
      const savedFontSize = localStorage.getItem('contentFontSize')
      if (savedFontSize) {
        this.contentFontSize = parseInt(savedFontSize)
      } else {
        this.contentFontSize = 16
        localStorage.setItem('contentFontSize', '16')
      }
      // 从本地存储加载页面全局字体大小
      const savedPageFontSize = localStorage.getItem('pageFontSize')
      if (savedPageFontSize) {
        this.pageFontSize = parseInt(savedPageFontSize)
      }
      this.updateGlobalPageFontSize()
      // 从本地存储加载背景颜色
      const savedBgColor = localStorage.getItem('currentBgColor')
      if (savedBgColor) {
        this.currentBgColor = savedBgColor
      }
      // 更新页面背景色 CSS 变量
      this.updatePageBgColor()
    },
    increaseFontSize() {
      if (this.contentFontSize < 99) {
        this.contentFontSize += 1
        localStorage.setItem('contentFontSize', this.contentFontSize)
        // 更新编辑器样式
        this.updateEditorStyle()
      }
    },
    decreaseFontSize() {
      if (this.contentFontSize > 10) {
        this.contentFontSize -= 1
        localStorage.setItem('contentFontSize', this.contentFontSize)
        // 更新编辑器样式
        this.updateEditorStyle()
      }
    },
    increasePageFontSize() {
      if (this.pageFontSize < 99) {
        this.pageFontSize += 1
        localStorage.setItem('pageFontSize', this.pageFontSize)
        this.updateGlobalPageFontSize()
      }
    },
    decreasePageFontSize() {
      if (this.pageFontSize > 10) {
        this.pageFontSize -= 1
        localStorage.setItem('pageFontSize', this.pageFontSize)
        this.updateGlobalPageFontSize()
      }
    },
    changeBgColor(color) {
      this.currentBgColor = color
      localStorage.setItem('currentBgColor', color)
      // 更新页面背景色 CSS 变量
      this.updatePageBgColor()
      // 更新 TinyMCE 编辑器的样式
      this.updateEditorStyle()
    },
    updateEditorStyle() {
      // 动态更新 TinyMCE 编辑器的样式
      const editor = tinymce.get('zwEdit')
      if (editor && editor.dom) {
        // 藏文需要额外的字号偏移
        const tibetanFontSize = this.contentFontSize + 9

        // 设置 CSS 变量
        const css = `
          :root {
            --editor-bg-color: ${this.currentBgColor};
            --editor-font-size: ${tibetanFontSize}px;
          }
          body {
            background-color: ${this.currentBgColor} !important;
            font-size: ${tibetanFontSize}px !important;
          }
          .tibetan-comment-mark {
            color: #ff4d4f !important;
            cursor: pointer;
            border-bottom: 1px dashed #ff4d4f;
          }
          .tibetan-comment-mark:hover {
            background-color: rgba(255, 77, 79, 0.1);
          }
        `

        // 移除所有旧的动态样式标签
        const styleTags = editor.dom.select('style[data-mce-dynamic-style]')
        styleTags.forEach(tag => editor.dom.remove(tag))

        // 添加新的样式标签
        const styleElement = editor.dom.create('style')
        styleElement.setAttribute('data-mce-dynamic-style', 'true')
        styleElement.innerHTML = css
        editor.getDoc().head.appendChild(styleElement)

        // 更新 body 的背景色和字体大小
        const body = editor.getBody()
        if (body) {
          body.style.setProperty('--editor-bg-color', this.currentBgColor)
          body.style.setProperty('--editor-font-size', tibetanFontSize + 'px')
          body.style.backgroundColor = this.currentBgColor
          body.style.fontSize = tibetanFontSize + 'px'
        }

        // 同时也添加样式到编辑器的 iframe 或容器
        const iframe = editor.getContainer().querySelector('iframe')
        if (iframe && iframe.contentDocument) {
          const iframeBody = iframe.contentDocument.body
          iframeBody.style.setProperty('--editor-bg-color', this.currentBgColor)
          iframeBody.style.setProperty('--editor-font-size', tibetanFontSize + 'px')
          iframeBody.style.backgroundColor = this.currentBgColor
          iframeBody.style.fontSize = tibetanFontSize + 'px'
        }

        // 更新编辑器边框颜色
        const editorElement = editor.getContainer()
        if (editorElement) {
          editorElement.style.backgroundColor = this.currentBgColor
          editorElement.style.borderColor = this.currentBgColor
        }

        // 绑定点击事件到批注标记
        this.bindCommentClickEvents()
      }
    },
    bindCommentClickEvents() {
      // 绑定点击事件到批注标记
      const editor = tinymce.get('zwEdit')
      if (editor) {
        const body = editor.getBody()
        const marks = body.querySelectorAll('.tibetan-comment-mark')

        // console.log('找到的批注标记数量:', marks.length)

        marks.forEach(mark => {
          // console.log('批注标记:', mark)

          // 检查是否已经绑定过事件（通过自定义属性）
          if (mark.hasAttribute('data-event-bound')) {
            // console.log('此标记已绑定过事件，跳过')
            return
          }

          // 确保样式应用
          mark.style.color = '#ff4d4f'
          mark.style.cursor = 'pointer'
          mark.style.borderBottom = '1px dashed #ff4d4f'

          mark.addEventListener('click', (e) => {
            // console.log('点击了批注标记, commentId:', e.target.getAttribute('data-comment-id'))
            e.preventDefault()
            e.stopPropagation()
            const commentId = e.target.getAttribute('data-comment-id')
            this.jumpToComment(commentId)
          })

          // 标记已绑定事件
          mark.setAttribute('data-event-bound', 'true')
        })
      }
    },
    jumpToComment(commentId) {
      // 跳转到对应的批注
      // console.log('=== jumpToComment 开始 ===')
      // console.log('commentId:', commentId)
      // console.log('tibetanComments:', this.tibetanComments)

      const commentIndex = this.tibetanComments.findIndex(c => c.id === Number(commentId))
      // console.log('commentIndex:', commentIndex)

      if (commentIndex !== -1) {
        const commentElement = document.getElementById(`tibetan-comment-${commentId}`)
        // console.log('commentElement:', commentElement)

        if (commentElement) {
          // 移除所有高亮
          document.querySelectorAll('.comment-highlight').forEach(el => {
            el.classList.remove('comment-highlight')
          })
          // 添加高亮
          commentElement.classList.add('comment-highlight')
          // console.log('已添加高亮类名')

          // 滚动到批注位置
          const rightBox = document.querySelector('.right-bottom')
          // console.log('rightBox:', rightBox)

          if (rightBox) {
            // 直接使用 rightBox 滚动，因为现在整个区域都是滚动的
            const scrollTop = commentElement.offsetTop - rightBox.offsetTop

            // console.log('rightBox.offsetTop:', rightBox.offsetTop)
            // console.log('commentElement.offsetTop:', commentElement.offsetTop)
            // console.log('计算 scrollTop:', scrollTop)

            rightBox.scrollTo({ top: scrollTop - 10, behavior: 'smooth' })
            // console.log('已执行滚动，最终 scrollTop:', scrollTop - 10)
          }
        } else {
          // console.log('未找到批注元素')
        }
      } else {
        // console.log('未在 tibetanComments 中找到对应的批注')
      }
      // console.log('=== jumpToComment 结束 ===')
    },
    setDialogBgColor() {
      // 设置弹框背景色
      this.$nextTick(() => {
        const dialogs = document.querySelectorAll('.el-dialog')
        dialogs.forEach(dialog => {
          if (dialog.offsetParent !== null) {
            dialog.style.backgroundColor = this.currentBgColor
          }
        })
      })
    },
    removeDialogBgColor() {
      // 移除弹框背景色
      const dialogs = document.querySelectorAll('.el-dialog')
      dialogs.forEach(dialog => {
        dialog.style.backgroundColor = ''
      })
    },
    updatePageBgColor() {
      // 更新页面背景色 CSS 变量
      document.documentElement.style.setProperty('--page-bg-color', this.currentBgColor)
    },
    updateGlobalPageFontSize() {
      // 更新全局页面字体大小，跨页面生效
      document.documentElement.style.setProperty('--global-page-font-size', this.pageFontSize + 'px')
    },
    // 批注相关方法
    handleAddComment() {
      this.isEditMode = false
      this.currentEditingCommentId = null
      this.commentForm.content = ''
      // 获取选中的文字
      const editor = tinymce.get('zwEdit')
      if (editor) {
        const selectedText = editor.selection.getContent({ format: 'text' })
        if (!selectedText || selectedText.trim() === '') {
          this.$message.warning('请先在藏文编辑区选中要批注的文字')
          return
        }
        this.currentSelectedText = selectedText
        this.commentDialogVisible = true
      } else {
        this.$message.warning('编辑器未初始化，请稍后再试')
      }
    },
    handleCommentSubmit() {
      if (this.commentForm.content.trim() === '') {
        this.$message.warning('请输入批注内容')
        return
      }

      if (this.isEditMode) {
        // 编辑批注
        const data = {
          path: this.filePath,
          id: this.currentEditingCommentId,
          comment: this.commentForm.content
        }
        editComment(data).then(res => {
          if (res.code === 200) {
            this.$message.success('编辑成功')
            this.commentDialogVisible = false
            this.loadTibetanComments()
          } else {
            this.$message.error(res.message || '编辑失败')
          }
        }).catch(() => {
          this.$message.error('编辑失败，请稍后重试')
        })
      } else {
        // 添加批注
        const editor = tinymce.get('zwEdit')
        if (editor) {
          // 在选中文本上添加红色标记
          const commentId = Date.now()

          // 使用 span 包裹选中文本，添加红色样式和点击事件
          editor.formatter.register('comment-mark', {
            inline: 'span',
            classes: ['tibetan-comment-mark'],
            styles: { color: 'red', cursor: 'pointer' },
            attributes: { 'data-comment-id': commentId.toString() }
          })
          editor.formatter.apply('comment-mark')

          // 获取标记后的文本
          const markedContent = editor.getContent()

          const data = {
            path: this.filePath,
            keyword: this.currentSelectedText,
            author: this.userInfo.nickname || '匿名',
            comment: this.commentForm.content,
            markedContent: markedContent,
            commentId: commentId
          }
          addComment(data).then(res => {
            if (res.code === 200) {
              this.$message.success('添加成功')
              this.commentDialogVisible = false
              this.loadTibetanComments()
            } else {
              this.$message.error(res.message || '添加失败')
            }
          }).catch(() => {
            this.$message.error('添加失败，请稍后重试')
          })
        }
      }
    },
    handleCommentAction(command, comment, index) {
      if (command === 'edit') {
        this.isEditMode = true
        this.currentEditingCommentId = comment.id
        this.currentSelectedText = comment.selected
        this.commentForm.content = comment.text
        this.commentDialogVisible = true
      } else if (command === 'delete') {
        this.$confirm('确定删除这条批注吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const data = {
            path: this.filePath,
            id: comment.id
          }
          delComment(data).then(res => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.loadTibetanComments()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }).catch(() => {
            this.$message.error('删除失败，请稍后重试')
          })
        }).catch(() => {})
      }
    },
    loadTibetanComments() {
      // 加载藏文批注
      getContent({
        path: this.filePath,
        langtype: 5
      }).then(res => {
        if (res.code === 200) {
          this.tibetanComments = res.data.comments || []
          // 重新应用批注标记到编辑器内容
          this.applyCommentMarks()
          // 重新绑定批注点击事件
          this.$nextTick(() => {
            this.bindCommentClickEvents()
          })
        }
      })
    },
    applyCommentMarks() {
      // 将批注标记应用到编辑器内容中
      const editor = tinymce.get('zwEdit')
      if (!editor) {
        // console.log('编辑器未初始化')
        return
      }
      if (!this.tibetanComments.length) {
        // console.log('没有批注数据')
        return
      }

      // 获取编辑器当前内容
      let content = editor.getContent()

      // console.log('=== 开始应用批注标记 ===')
      // console.log('编辑器是否已初始化:', !!editor)
      // console.log('批注数据:', this.tibetanComments)
      // console.log('编辑器原始内容长度:', content.length)

      // 为每个批注找到对应文本并标记
      this.tibetanComments.forEach(comment => {
        if (comment.selected && comment.id !== undefined && comment.id !== null) {
          // 检查是否已经被标记过
          if (content.includes(`data-comment-id="${comment.id}"`)) {
            // console.log(`批注 ${comment.id} 已经标记过，跳过`)
            return
          }

          // console.log(`尝试匹配批注 ${comment.id}:`, comment.selected)

          // 查找文本在内容中的位置
          const textIndex = content.indexOf(comment.selected)
          // console.log(`文本位置:`, textIndex)

          if (textIndex !== -1) {
            // 找到文本，在其前后添加 span 标签
            const before = content.substring(0, textIndex)
            const after = content.substring(textIndex + comment.selected.length)
            content = before + `<span class="tibetan-comment-mark" data-comment-id="${comment.id}">${comment.selected}</span>` + after
            // console.log(`✓ 成功标记批注 ${comment.id}`)
          } else {
            // console.log(`✗ 批注 ${comment.id} 未找到匹配的文本`)
          }
        }
      })

      // console.log('处理后的内容长度:', content.length)
      // console.log('是否需要更新编辑器:', content !== editor.getContent())

      // 更新编辑器内容
      if (content !== editor.getContent()) {
        // console.log('正在更新编辑器内容...')

        // 使用 onSetContent 事件确保 DOM 更新完成
        const onSetContentHandler = (e) => {
          // console.log('setContent 完成，开始绑定点击事件...')
          editor.off('SetContent', onSetContentHandler)
          setTimeout(() => {
            this.bindCommentClickEvents()
          }, 100)
        }

        editor.on('SetContent', onSetContentHandler)
        editor.setContent(content)
        // console.log('编辑器内容已更新，等待 DOM 渲染...')
      } else {
        // console.log('内容无需更新，直接绑定点击事件')
        this.bindCommentClickEvents()
      }
      // console.log('=== 批注标记应用完成 ===')
    },
    escapeRegExp(string) {
      // 转义正则表达式特殊字符
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeBoxChange)
  }
}
